import React from 'react'
import { useSelector } from 'react-redux'
import contractApi from 'services/api/contracts'

import CanadaForm from './CanadaForm'
import NonCanadaForm from './NonCanadaForm'

const HotelSetupLegalInfo = ({ onStepComplete }) => {
  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)

  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(() => {
    contractApi.lagelInfo.get().then(data => {
      if (data.useExistingW9) {
        contractApi.lagelInfo.add({ UseExistingW9: true }).then(() => {
          onStepComplete()
        })
        return
      }
      setIsLoading(false)
    })
  }, [onStepComplete])

  if (isLoading) return null

  if (cultureCode === 'en-CA') {
    return <CanadaForm onStepComplete={onStepComplete} />
  } else {
    return <NonCanadaForm onStepComplete={onStepComplete} />
  }
}

export default HotelSetupLegalInfo
